/* v2.1 sync 2026-03-08 */
/**
 * Crisis-Tech Shopify Theme — JavaScript
 * Handles: scroll header, mobile menu, scroll-reveal, counters, cart drawer, product page, customer type
 */

(function() {
  'use strict';

  // ========================
  // Header scroll effect
  // ========================
  var header = document.querySelector('.header');
  var topbar = document.querySelector('.header__topbar');

  function updateHeader() {
    if (!header) return;
    if (window.scrollY > 20) {
      header.classList.add('header--scrolled');
      header.classList.remove('header--transparent');
      if (topbar) topbar.style.display = 'none';
    } else {
      header.classList.remove('header--scrolled');
      header.classList.add('header--transparent');
      if (topbar) topbar.style.display = '';
    }
  }
  window.addEventListener('scroll', updateHeader, { passive: true });
  updateHeader();

  // ========================
  // Mobile menu
  // ========================
  var burger = document.querySelector('.header__burger');
  var mobileMenu = document.querySelector('.mobile-menu');

  if (burger && mobileMenu) {
    burger.addEventListener('click', function() {
      mobileMenu.classList.toggle('is-open');
      var isOpen = mobileMenu.classList.contains('is-open');
      burger.setAttribute('aria-expanded', isOpen);
      burger.innerHTML = isOpen
        ? '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>'
        : '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="18" x2="21" y2="18"/></svg>';
    });
  }

  // ========================
  // Scroll-reveal (IntersectionObserver)
  // ========================
  function initReveal() {
    var els = document.querySelectorAll('.reveal:not(.is-visible)');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach(function(el) { el.classList.add('is-visible'); });
      return;
    }

    var revealObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.05, rootMargin: '0px 0px -20px 0px' });

    els.forEach(function(el) { revealObserver.observe(el); });
  }

  initReveal();
  document.addEventListener('shopify:section:load', initReveal);

  // ========================
  // Customer type selector
  // ========================
  document.querySelectorAll('[data-customer-card]').forEach(function(card) {
    card.addEventListener('click', function() {
      document.querySelectorAll('[data-customer-card]').forEach(function(c) {
        c.classList.remove('is-selected', 'glow-primary');
      });
      card.classList.add('is-selected', 'glow-primary');
      var ctaEl = card.querySelector('.customer-type__cta');
      if (ctaEl) ctaEl.style.display = 'block';
      document.querySelectorAll('[data-customer-card]').forEach(function(c) {
        if (c !== card) {
          var other = c.querySelector('.customer-type__cta');
          if (other) other.style.display = 'none';
        }
      });
    });
  });

  // ========================
  // Cart Drawer
  // ========================
  var cartDrawer = document.getElementById('CartDrawer');
  if (cartDrawer) {
    // Open
    document.querySelectorAll('[data-cart-toggle]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        cartDrawer.classList.add('is-open');
        cartDrawer.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      });
    });

    // Close
    document.querySelectorAll('[data-cart-close]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        cartDrawer.classList.remove('is-open');
        cartDrawer.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      });
    });

    // Escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && cartDrawer.classList.contains('is-open')) {
        cartDrawer.classList.remove('is-open');
        cartDrawer.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
    });

    // Quantity change
    cartDrawer.querySelectorAll('[data-qty-minus], [data-qty-plus]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var line = parseInt(btn.getAttribute('data-line'));
        var isMinus = btn.hasAttribute('data-qty-minus');
        var qtySpan = btn.parentElement.querySelector('span');
        var currentQty = parseInt(qtySpan.textContent);
        var newQty = isMinus ? Math.max(0, currentQty - 1) : currentQty + 1;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: line, quantity: newQty })
        }).then(function() { location.reload(); });
      });
    });

    // Remove item
    cartDrawer.querySelectorAll('[data-remove-item]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var line = parseInt(btn.getAttribute('data-line'));
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: line, quantity: 0 })
        }).then(function() { location.reload(); });
      });
    });
  }

  // ========================
  // Product page — thumbnail gallery
  // ========================
  document.querySelectorAll('[data-thumb-index]').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var src = thumb.getAttribute('data-full-src');
      var mainImg = document.querySelector('.product-main__image-wrap img');
      if (mainImg && src) {
        mainImg.src = src;
        document.querySelectorAll('[data-thumb-index]').forEach(function(t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      }
    });
  });

  // Product page — quantity
  var qtyMinus = document.querySelector('[data-product-qty-minus]');
  var qtyPlus = document.querySelector('[data-product-qty-plus]');
  var qtyInput = document.getElementById('ProductQty');
  if (qtyMinus && qtyPlus && qtyInput) {
    qtyMinus.addEventListener('click', function() { qtyInput.value = Math.max(1, parseInt(qtyInput.value) - 1); });
    qtyPlus.addEventListener('click', function() { qtyInput.value = parseInt(qtyInput.value) + 1; });
  }

})();